/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import CashInvoiceSales from "./CashInvoiceSales";
import CashInvoicePurchase from "./CashInvoicePurchase";
// import NoData from "../../../components/NoData/NoData";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useSelector } from "react-redux";
import {
  isEmpty,
  // isUndefined
} from "lodash";
import { permissionCheck } from "../../../utils/permission";
// import TaxInvoiceCreate from "../../ElectronicBill/Tax/TaxInvoiceCreate";
import SalesInvoice from "../Trade/SalesInvoice";
import PurchaseInvoice from "../Trade/PurchaseInvoice";


import {
  getCashReceiptsSalesExcel, getCashReceiptsPurchaseExcel,
  // excelUploadCash
} from "../../../apis/cash-receipts";
import { getExcelDownParams } from "../../../utils/params";
import { downExcelFile } from "../../../utils/download";

// import { viewLoading } from '../../../utils/loading';
// import systemAlert from "../../../utils/systemAlert";
// import cashSample from "../../../assets/file/cashSample.xls";

const ElectronicCashBill = (props) => {
  const history = useHistory();
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const { company } = useSelector((store) => store.Profile);

  const [activeTab, setActiveTab] = useState(0);
  const [targetPermission, setTargetPermission] = useState(null);
  const [scrapingPermission, setScrapingPermission] = useState(null);

  const [open, setOpen] = useState(false);

  const [invoiceOpen, setInvoiceOpen] = useState(false);
  const [invoiceType, setInvoiceType] = useState("");
  const [formType, setFormType] = useState("");

  const [form, setForm] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'CASH_INVOICE');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "CASH_INVOICE");
      }
      const scrapingPermission = permissions.find(p => p.code === 'FINANCE_SCRAPING');
      setScrapingPermission(scrapingPermission);
    }
  }, [permissions]);

  const _setActiveTab = (value) => {
    history.push(`/electronic/bill-cash?tab=${value}`);
  };

  const tabList = [
    { label: "매출", action: _setActiveTab, value: 'sales' },
    { label: "매입", action: _setActiveTab, value: 'purchases' },
    // { label: "발행내역", action: _setActiveTab, value: 'history' },
  ];

  useEffect(() => {
    setForm(null);
  }, [activeTab]);


  // const uploadExcelFile = (e) => {
  //   const file = e.target.files[0];

  //   if (!isUndefined(file))
  //   {
  //     systemAlert(`"${file.name}" 파일을 업로드 하시겠습니까?`, {
  //       buttons: [
  //         {
  //           color: "text",
  //           label: "취소",
  //         },
  //         {
  //           label: "확인",
  //           onClick: () => {
  //             viewLoading("현금영수증 발행중 입니다.");
  //             const formData = new FormData();
  //             formData.append("file", file);

  //             excelUploadCash(formData)
  //               .then(() => {
  //                 // 페이지 reload 없음.
  //                 //filterSubmit();
  //                 //setInvoiceType(type);
  //                 //setOpen(false);
  //                 systemAlert('현금영수증 일괄 발행되었습니다.');
  //                 window.location.reload()
  //               })
  //               .finally(() => {
  //                 viewLoading(false)
  //               })

  //           },
  //         },
  //       ],
  //     });
  //   }

  // };

  const headerButtons = [
    // {
    //   isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
    //   color: "gray-line",
    //   label: (
    //     <>
    //       일괄발생 샘플 <i className="mdi mdi-arrow-collapse-down" />
    //     </>
    //   ),
    //   action: () => {
    //     const a = document.createElement("a");
    //     a.href = cashSample;
    //     a.style.display = "none";
    //     a.download = "cashSample";
    //     document.body.appendChild(a);
    //     a.click()
    //   },
    // },
    // {
    //   isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
    //   label: "일괄발행 엑셀 업로드",
    //   color: "gray-line",
    //   key: "purchases_cash",
    //   type: "excelfile",
    //   onChange: (e) => uploadExcelFile(e),
    // },
    {
      color: "gray-line",
      label: (
        <>
          엑셀다운로드 <i className="mdi mdi-arrow-collapse-down" />
        </>
      ),
      action: () => {
        switch (activeTab) {
          case 'sales':
            getCashReceiptsSalesExcel(getExcelDownParams(form)).then((res) => {
              let title = '매출_현금영수증_목록.xlsx';
              if (company && !isEmpty(company)) {
                title = company.name + '_' + title;
              }
              downExcelFile(res, title);
            });
            break;
          case 'purchases':
            getCashReceiptsPurchaseExcel(getExcelDownParams(form)).then((res) => {
              let title = '매입_현금영수증_목록.xlsx';
              if (company && !isEmpty(company)) {
                title = company.name + '_' + title;
              }
              downExcelFile(res, title);
            });
            break;
          default:
            break;
        }
      },
    },
    {
      isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      label: "현금영수증 발행",
      action: () => {
        setOpen(true);
      },
    },
    // {
    //   label: '세금계산서 발행',
    //   color: 'line',
    //   action: () => {
    //     setTaxInvoiceOpen(true)
    //   }
    // },
    {
      isHide: activeTab === 'purchases' || (targetPermission && targetPermission.level <= 1),
      label: "매출 거래명세서 등록",
      action: () => {
        setInvoiceType("sales");
        setFormType("create");
        setInvoiceOpen(true);
      },
    },
    {
      isHide: activeTab === 'sales' || (targetPermission && targetPermission.level <= 1),
      label: "매입 거래명세서 등록",
      action: () => {
        setInvoiceType("purchase");
        setFormType("create");
        setInvoiceOpen(true);
      },
    },

  ];


  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  const handleExcelDown = ({ form }) => {
    setForm(form);
  };

  return (
    !isEmpty(targetPermission) && (
      <>
        <PageHeader
          title={"현금 영수증"}
          tabList={tabList}
          activeTab={activeTab}
          buttons={headerButtons}
        />
        {activeTab === 'sales' && (
          <CashInvoiceSales
            open={open}
            setOpen={setOpen}
            permission={targetPermission}
            scrapingPermission={scrapingPermission}
            excelDown={handleExcelDown}
          />
        )}
        {activeTab === 'purchases' && (
          <CashInvoicePurchase
            permission={targetPermission}
            scrapingPermission={scrapingPermission}
            excelDown={handleExcelDown}
          />
        )}
        {/* {activeTab === 'history' && <><NoData /></>} */}

        {activeTab === "sales" && (
          <SalesInvoice
            isTableHide={true}
            permission={targetPermission}
            open={invoiceOpen}
            setOpen={setInvoiceOpen}
            invoiceType={invoiceType}
            setInvoiceType={setInvoiceType}
            formType={formType}
            setFormType={setFormType}
          />
        )}
        {activeTab === "purchases" && (
          <PurchaseInvoice
            isTableHide={true}
            permission={targetPermission}
            open={invoiceOpen}
            setOpen={setInvoiceOpen}
            invoiceType={invoiceType}
            setInvoiceType={setInvoiceType}
            formType={formType}
            setFormType={setFormType}
          />
        )}

      </>
    )
  );
};

export default ElectronicCashBill;
